// type guard: tells TS that object has the property
export function hasOwnProperty<X extends Record<PropertyKey, unknown>, Y extends PropertyKey>(
  obj: X,
  prop: Y
): obj is X & Record<Y, unknown> {
  // eslint-disable-next-line no-prototype-builtins
  return prop in obj;
}
